export default __webpack_public_path__ + "static/logo-apl-0c89823445416c904f3212ef7813aa8a.png";